<form class="e-invoice-sign-up-form ups-form"
      [formGroup]="formGroup"
      (ngSubmit)="onFormSubmit($event, formGroup.value)">
    <div class="form-body">
        <div class="deprecated-key-values">
            <div class="key-value">
                <div class="key">{{ 'eInvoiceSignUp.Form.CompanyName' | translate }}</div>
                <div class="value">{{ contact?.CompanyName }}</div>
            </div>
            <div class="key-value">
                <div class="key">{{ 'eInvoiceSignUp.Form.ContactName' | translate }}</div>
                <div class="value">{{ contact?.ContactName }}</div>
            </div>
            <div class="key-value">
                <div class="key">{{ 'eInvoiceSignUp.Form.Address' | translate }}</div>
                <div class="value">
                    {{ contact?.StreetAddress }}<br>
                    {{ contact?.ApartmentSuite }}<br>
                    {{ contact?.City }}, {{ contact?.State || contact?.ProvinceRegion }}<br>
                    {{ contact?.Country }} {{ contact?.Zip }}
                </div>
            </div>
            <div class="key-value">
                <div class="key">{{ 'eInvoiceSignUp.Form.PhoneNumber' | translate }}</div>
                <div class="value">{{ contact?.TelephoneNo }}</div>
            </div>
            <div class="key-value">
                <div class="key">{{ 'eInvoiceSignUp.Form.FaxNumber' | translate }}</div>
                <div class="value">{{ contact?.FaxNo }}</div>
            </div>
            <div class="key-value">
                <div class="key">{{ 'eInvoiceSignUp.Form.Email' | translate }}</div>
                <div class="value">{{ contact?.Email }}</div>
            </div>
        </div>
    </div>

    <div class="form-footer">
        <div class="form-actions">
            <button mat-raised-button color="accent" class="form-action" [disabled]="!formGroup.valid">
                {{ 'eInvoiceSignUp.Form.Actions.SignUp' | translate }}
            </button>
        </div>
    </div>
</form>
